import { getVisitorId, getStoredVisitor } from '../fingerprint/get-visitor-id.js';
import { getWidgetSession } from '../session/widget-session.js';

/** Sync visitor id for envelope build (session → localStorage). */
export function resolveAnalyticsVisitorIdSync(): string | null {
  const session = getWidgetSession();
  if (session?.visitorId) return session.visitorId;

  const stored = getStoredVisitor();
  return stored?.visitorId ?? null;
}

/**
 * Ensures a visitor id exists before analytics flush.
 */
export async function ensureAnalyticsVisitorId(): Promise<string | null> {
  const existing = resolveAnalyticsVisitorIdSync();
  if (existing) return existing;

  if (typeof window === 'undefined') return null;

  try {
    return await getVisitorId();
  } catch {
    return null;
  }
}
